import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { CommonModule, CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { AfterContentInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, NgZone, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
 
// import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { Subject, takeUntil } from 'rxjs'; 
import { Router, RouterModule } from '@angular/router'; 
import { AppMessageService } from '../../app.message.service';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import { Dialog } from '@angular/cdk/dialog';
import { SearchResultsComponent } from '../search-results/search-results.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    // LottieComponent,
    CommonModule, MatBadgeModule,MatTooltipModule,MatMenuModule,
          RouterModule],
  templateUrl: './navbar.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrl: './navbar.component.scss',
  providers: [
    CurrencyPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class NavbarComponent implements AfterViewInit, OnInit, AfterContentInit {
  // @Input()
  // sidenav!: MatSidenav;
  showVideo = false;
  mobileQuery!: MediaQueryList;
  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);

 
  destroyed = new Subject<void>();
  switchNav: boolean = false;


  total = '000,000.00'

  constructor(
    private media: MediaMatcher,
    private currencyPipe: CurrencyPipe,
    private msgService: AppMessageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private ref: ChangeDetectorRef,
    public dialog: Dialog,
    private ngZone: NgZone,
    private route: Router,
    private breakpointObserver: BreakpointObserver) {
  }
  ngAfterContentInit(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        this.mobileQuery = this.media.matchMedia('(max-width: 600px)');
        this.ref.detectChanges()

        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            const size = this.displayNameMap.get(query);
            if (size === 'Medium' || size === 'Large' || size === 'XLarge') {
              // this.switchNav = false;
              this.ref.detectChanges()
            } else {
              // this.switchNav = true;
              this.ref.detectChanges()

              // this.sidenav.close();
            }
            // this.currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
          }
        }
      });

  }
  ngOnInit(): void {
    this.msgService.notificationAnnounced$.subscribe(d => {
      if (d.topic === 'TOTAL') {
        this.total = this.currencyPipe.transform(localStorage.getItem('total'), ' ')!
        this.ref.detectChanges()

      }
    })
    if (isPlatformBrowser(this.platformId)) {
      this.media.matchMedia('(max-width: 840px)').addEventListener('change', (e) => {
        if (e.matches) {
          this.switchNav = true
         } else {
          this.switchNav = false

        }
      })


      if (localStorage.getItem('sfncart')) {
        this.total = this.currencyPipe.transform(localStorage.getItem('total'), ' ')! === '0.00' ? '000,000.00' : this.currencyPipe.transform(localStorage.getItem('total'), ' ')!
        this.ref.detectChanges()


      } else {

      }
    }
  }
 

  ngAfterViewInit(): void {
    this.ngZone.run(() => {
      this.showVideo = true
    });
    this.ref.detectChanges()
    // this.openSearch()
  }

  navopen() {
    this.msgService.pushNotification('SIDENAV', '');
  }

  download() {
    this.route.navigateByUrl('/softnet-computers-cart')
  }

  openSearch(){
    this.dialog.open(SearchResultsComponent, {
      width: '100vw',
      minHeight: '100%',
      height: '100vh',
      // minHeight: '100%',
      data: {

      },
      hasBackdrop: true,
      disableClose: false

    });
  }
}
